module.exports = __webpack_public_path__ + "img/icn_instagram.240aa2d6.svg";